import { nanoid } from 'nanoid';

// HEAD DATA
export const headData = {
  title: '', // e.g: 'Name | Developer'
  lang: '', // e.g: en, es, fr, jp
  description: '', // e.g: Welcome to my website
};

// HERO DATA
export const heroData = {
  title: 'Olá, meu nome é',
  name: 'Ana Laura :)',
  subtitle: ' ',
  cta: 'Saiba mais',
};

// ABOUT DATA
export const aboutData = {
  img: 'profile.jpeg',
  paragraphOne:
    'Olá!  Me chamo Ana Laura, tenho 18 anos e moro em Fortaleza - CE. Atualmente estou cursando 3º semestre de Engenharia da Computação. Sou Estagiária na área de Internet das Coisas no VORTEX - Programa de Formação Tecnológica da Universidade de Fortaleza. ',
  paragraphTwo:
    'Estou sempre buscando adquirir mais conhecimento, sou apaixonada pelo que estudo e estou sempre aberta à novos desafios.',
  paragraphThree:
    'Sou familiarizada com Javascript, Java, HTML e CSS. No momento estou aprendendo mais sobre computação em nuvem e desenvolvimento front-end.',
  resume: '', // if no resume, the button will not show up
};

// PROJECTS DATA
export const projectsData = [
  {
    id: nanoid(),
    img: 'ocariot.png',
    title: 'OCARIoT',
    info:
      'OCARIoT é um projeto co-financiado pelo Programa HORIZON 2020 da União Européia e pelo Ministério da Ciência, Tecnologia e Inovação do Brasil através da Rede Nacional de Ensino e Pesquisa (RNP). O projeto começou em novembro de 2017 e durou cerca de três anos.',
    info2:
      'O principal objetivo do OCARIoT é promover a melhoria dos transtornos alimentares e físicos e também a prevenção do início da obesidade em crianças (entre 9 e 12 anos). Para isso, a OCARIoT desenvolveu uma solução personalizada de coaching baseada na IoT que orienta as crianças a adotar comportamentos saudáveis ​​de alimentação e atividade física. A rede de IoT permitirá observar os padrões de atividade da vida cotidiana da criança, a evolução da saúde, os parâmetros fisiológicos e comportamentais e os dados ambientais. ',
    url: 'http://www.ocariot.com.br',
    repo: '', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'blizzardnovo.jpg',
    title: 'Blizzard',
    info:
      'Este projeto busca desenvolver um sistema de monitoramento que controle diversos aparelhos, e estes viabilizam a economia de energia por meio do desligamento de dispositivos eletrônicos à distância, inicialmente implantado nas salas da Universidade de Fortaleza.',
    info2:
      'A integração dos dispositivos eletrônicos é feita por meio do protocolo SNMP entre ESP32 e Zabbix.',
    url: '',
    repo: '', // if no repo, the button will not show up
  },
  // {
  // id: nanoid(),
  // img: '',
  // 'sucbaby.png',
  // title: '',
  // 'SUCBABY',
  // info: '',
  // 'O SUCBABY é um protótipo que foi desenvolvido para aferir a força de sucção de bebês recém-nascidos, além de auxiliar a abertura de um campo de estudo com dados númericos precisos sobre a força necessária para a extração do leite materno. O dado matemático colaborará com o profissional de saúde no diagnóstico considerando que não somente a força de extração que impede a amamentação, mas sim a falta de um instrumento que faça essa medição.',
  // info2: '',
  // url: '',
  // repo: '', // if no repo, the button will not show up
  // },
];

// CONTACT DATA
export const contactData = {
  cta: '',
  btn: 'E-mail',
  email: 'mailto:alaurabp@hotmail.com',
};

// FOOTER DATA
export const footerData = {
  networks: [
    {
      id: nanoid(),
      name: 'instagram',
      url: 'https://www.instagram.com/llaurabp',
    },
    {
      id: nanoid(),
      name: 'whatsapp',
      url:
        'https://api.whatsapp.com/send?phone=5585996919727&text=Ol%C3%A1!%20Vim%20pelo%20seu%20portf%C3%B3lio%20%3A)',
    },
    {
      id: nanoid(),
      name: 'linkedin',
      url: 'https://www.linkedin.com/in/ana-laura-borges-680b841a1/',
    },
    {
      id: nanoid(),
      name: 'github',
      url: 'https://www.github.com/llaurabp',
    },
  ],
};

// Github start/fork buttons
export const githubButtons = {
  isEnabled: false, // set to false to disable the GitHub stars/fork buttons
};
